import { SHIPPING_MULTICD } from 'App/featuresFlags';
import useGetTags from '../useGetTags';

function useHasShippingMultiCD(): boolean {
  const tags = useGetTags();
  return tags.includes(SHIPPING_MULTICD);
}

export default useHasShippingMultiCD;
